export const DEFAULT_WEFAT_EXTERNAL_LINK_TARGET = '_blank';
export const WEFAT_EXTERNAL_LINK_TARGET_KEY = Symbol('wefat-external-link-target');
export function resolveWefatExternalLinkRel(target, current = '') {
    const tokens = new Set(current.split(/\s+/u).filter((token) => token.length > 0));
    tokens.delete('opener');
    tokens.add('noreferrer');
    if (target === '_blank')
        tokens.add('noopener');
    return [...tokens].sort().join(' ');
}
export function applyWefatExternalLinkPolicy(root, target) {
    for (const link of root.querySelectorAll('a[href]')) {
        link.target = target;
        link.rel = resolveWefatExternalLinkRel(target, link.rel);
    }
}
//# sourceMappingURL=external-link-policy.js.map